import { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ReactTable } from "components/Table";
import SelectBox from "components/elements/selectBox";
import { getStaffs } from "actions/teamActions";
import { getPromotionV2Shops } from "actions/promotionv2Action";
import { Modaleditall } from "./modal";

function Listshops(props) {
	const [isOpenModalEditAll, setIsOpenModalEditAll] = useState(false);
	const [page, setPage] = useState(1);
	const [sizePerPage, setSizePerPage] = useState(50);
	const [searchText, setSearchText] = useState("");
	const [totalSize, setTotalSize] = useState(0);
	const [staffs, setStaffs] = useState([]);
	const [filter, setFilter] = useState({});
	const [editall, setEditAll] = useState({});
	const [modal_type, setModalType] = useState("plus");

	const { t } = useTranslation();
	var { listpromotionv2shops, totalsize } = props.promotionv2;
	var { getPromotionV2Shops, getStaffs } = props;

	useEffect(() => {
		getStaffs({ sizeperpage: 100 }).then((data) => {
			setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email })) || []);
		});
	}, [getStaffs]);

	useEffect(() => {
		getPromotionV2Shops({ page, sizeperpage: sizePerPage, search: searchText, filter });
	}, [getPromotionV2Shops, page, sizePerPage, searchText, filter]);

	useEffect(() => {
		setTotalSize(totalsize);
	}, [totalsize]);

	const onClickOpenModalEditAll = (modal_type = "plus") => {
		setIsOpenModalEditAll(!isOpenModalEditAll);
        setEditAll({});
        setModalType(modal_type);
	};

	const onClickEdit = (modal_type = "plus", cell = "", row = []) => {
		var editall_tmp = {};
		editall_tmp.type = cell;
		editall_tmp.value = row[cell]?.promotions?.value || "0";
		editall_tmp.time = row[cell]?.promotions?.time || "0";
		editall_tmp.shops_selected = [row?._id] || [];
		editall_tmp.products_selected = row[cell]?.promotions?.products || [];

		setIsOpenModalEditAll(!isOpenModalEditAll);
        setEditAll(editall_tmp);
        setModalType(modal_type);
	};

	const columns = [{
		dataField: '_id',
		text: "",
		sort: true,
		style: {
			width: "50px",
		},
		formatter: (cell, row, rowIndex) => rowIndex + 1
	}, {
		dataField: 'name',
		text: t("Shop Name"),
		sort: true,
	}, {
		dataField: 'note',
		text: t("Note"),
		sort: true,
	}, {
		dataField: 'member_note',
		text: t("Member Note"),
		sort: true,
	}, {
		dataField: 'type_1',
		text: t("Type 1"),
		sort: true,
		formatter: (cell, row, rowIndex) => (
			<Fragment>
				<span className="text-info fw-bold">{cell?.promotions?.value}%</span>
				<span className="me-2 ms-2">-</span>
				<span className="">{cell?.products?.length} {t("products")}</span>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("plus", "type_1", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("Add")}>
					<i className="ki-duotone ki-plus-circle fs-2">
						<span className="path1"></span>
						<span className="path2"></span>
					</i>
				</div>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("minus", "type_1", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("View")}>
					<i class="ki-duotone ki-eye fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
						<span class="path3"></span>
					</i>
				</div>
			</Fragment>
		),
	}, {
		dataField: 'type_2',
		text: t("Type 2"),
		sort: true,
		formatter: (cell, row, rowIndex) => (
			<Fragment>
				<span className="text-info fw-bold">{cell?.promotions?.value}%</span>
				<span className="me-2 ms-2">-</span>
				<span className="">{cell?.products?.length} {t("products")}</span>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("plus", "type_2", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("Add")}>
					<i className="ki-duotone ki-plus-circle fs-2">
						<span className="path1"></span>
						<span className="path2"></span>
					</i>
				</div>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("minus", "type_2", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("View")}>
					<i class="ki-duotone ki-eye fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
						<span class="path3"></span>
					</i>
				</div>
			</Fragment>
		),
	}, {
		dataField: 'type_3',
		text: t("Type 3"),
		sort: true,
		formatter: (cell, row, rowIndex) => (
			<Fragment>
				<span className="text-info fw-bold">{cell?.promotions?.value}%</span>
				<span className="me-2 ms-2">-</span>
				<span className="">{cell?.products?.length} {t("products")}</span>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("plus", "type_3", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("Add")}>
					<i className="ki-duotone ki-plus-circle fs-2">
						<span className="path1"></span>
						<span className="path2"></span>
					</i>
				</div>
				<div className="btn btn-icon"  onClick={() => { onClickEdit("minus", "type_3", row) }} data-tooltip-id="my-tooltip" data-tooltip-content={t("View")}>
					<i class="ki-duotone ki-eye fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
						<span class="path3"></span>
					</i>
				</div>
			</Fragment>
		),
	}, {
		dataField: 'staff',
		text: t("Staff"),
		sort: true,
		formatter: (cell, row, rowIndex) => cell ? cell.map((v, i) => v?.email).join() : ""
	}];

	const groupButton = () => {
		return (
            <div className="mb-5 d-flex gap-2 flex-wrap">
				<button onClick={() => { onClickOpenModalEditAll("plus") }} type="button" className="btn btn-primary btn-sm me-2 mb-2">
					<i className="ki-duotone ki-plus-circle fs-2">
						<span className="path1"></span>
						<span className="path2"></span>
					</i> {t("Add All")}
				</button>
				<button onClick={() => { onClickOpenModalEditAll("minus") }} type="button" className="btn btn-danger btn-sm me-2 mb-2">
					<i class="ki-duotone ki-eye fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
						<span class="path3"></span>
					</i> {t("View All")}
				</button>
				<SelectBox
					options={staffs}
					name="filter_staff"
					value={filter.staff || ""}
					onChange={(data) =>
						setFilter((prev) => ({
							...prev,
							staff: data.value || "",
						}))
					}
					className="cotik-select-virtual me-2 mb-2"
				/>
			</div>
		);
	}

	const handleTableChange = (type, { page, sizePerPage, searchText }) => {
		if (type === "search") {
			setPage(1);
			setSizePerPage(50);
			setSearchText(searchText);
		} else {
			setPage(page || 1);
			setSizePerPage(sizePerPage);
		}
	}

	const sizePerPageList = [
		{
			text: '10', value: 10
		},
		{
			text: '50', value: 50
		},
		{
			text: '100', value: 100
		},
		{
			text: '150', value: 150
		},
		{
			text: '200', value: 200
		},
		{
			text: 'All', value: totalsize || 50
		}
	];

	return (
		<Fragment>
			<div className="card mb-5 mb-xl-10">
				<div className="card-body p-9">
					<div className="al-variants-table al-max-height-table-cus">
						<ReactTable columns={columns} data={listpromotionv2shops} groupButton={groupButton} handleTableChange={handleTableChange} page={page} sizePerPage={sizePerPage} totalSize={totalSize} alClassName="table-layout-inherit" sizePerPageList={sizePerPageList} />
						{isOpenModalEditAll ? <Modaleditall openModal={onClickOpenModalEditAll} isOpenModalEditAll={isOpenModalEditAll} editall={editall} modal_type={modal_type} /> : ''}
					</div>
				</div>
			</div>
		</Fragment>
	);
}

Listshops.propTypes = {
	getStaffs: PropTypes.func.isRequired,
	getPromotionV2Shops: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
	promotionv2: state.promotionv2
});
const mapDispatchToProps = {
	getStaffs,
	getPromotionV2Shops,
}

export default connect(mapStateToProps, mapDispatchToProps)(Listshops);